import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Button,
  IconButton,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CookieOutlinedIcon from "@mui/icons-material/CookieOutlined";
import { getConsentFromCookie, saveConsentToCookie } from "./cookieUtils";
import ClarityScript from "./ClarityScript";

export default function ConsentManager() {
  const [showConsentModal, setShowConsentModal] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      try {
        const consent = getConsentFromCookie();
        if (!consent) {
          setShowConsentModal(true);
        } else {
          ClarityScript(consent);
        }
      } catch (error) {
        console.error("Failed to check consent:", error);
      }
    };

    checkConsent();
  }, []);

  const onAccept = () => {
    const consent = {
      analytics_Storage: "granted",
      ad_Storage: "granted",
    };

    try {
      saveConsentToCookie(consent);
      ClarityScript(consent);
      setShowConsentModal(false);
    } catch (error) {
      console.error("Failed to save consent:", error);
      setShowConsentModal(false);
    }
  };

  const onReject = () => {
    const consent = {
      analytics_Storage: "denied",
      ad_Storage: "denied",
    };

    try {
      saveConsentToCookie(consent);
      ClarityScript(consent);
      setShowConsentModal(false);
    } catch (error) {
      console.error("Failed to save consent:", error);
      setShowConsentModal(false);
    }
  };

  return (
    <Dialog
      open={showConsentModal}
      onClose={onReject}
      maxWidth="sm"
      fullWidth
      aria-labelledby="clarity-consent-title"
    >
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CookieOutlinedIcon />
            <Typography variant="h6">Cookie Consent</Typography>
          </Box>
          <IconButton
            onClick={onReject}
            size="small"
            aria-label="Close dialog"
          >
            <CloseOutlinedIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, pb: 0 }}
      >
        <Typography variant="body1">
          We use Microsoft Clarity to analyze how you use our website. This
          helps us improve your experience and provide better services.
        </Typography>
      </DialogContent>

      <Box sx={{ p: 3 }}>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="contained"
            onClick={onAccept}
            fullWidth
            size="large"
            disableElevation
          >
            Accept
          </Button>

          <Button
            variant="outlined"
            onClick={onReject}
            fullWidth
            size="large"
            disableElevation
          >
            Reject
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
